import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Column, Row } from 'Components/Grid';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button } from 'Components/ui';

const MainWrapper = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 30px 30px 30px;

  .headerMenu {
    display: flex;
    align: center;
  }

  .clickable {
    cursor: pointer;
  }

  .container {
    box-shadow: 0px 6px 20px var(--vo-cloud);
    border-radius: 8px;
    background-color: var(--vo-white);
    display: flex;
    flex-direction: column;
    padding: 24px;
    margin-top: 32px;

    .subcontainer {
      width: 100%;
      margin-top: 24px;
    }

    h1.title {
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      color: var(--color-brand);
      margin: 0px;
      margin-bottom: 9px;
    }

    h2.subtitle {
      color: var(--vo-slate);
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      margin: 0px;
    }
  }

  #help {
    width: 48px !important;
    height: 48px !important;
    margin-top: 124px;

    img {
      margin: 0px;
    }
  }

  button {
    display: flex;
    justify-content: center;
  }
`;

const Subtitle = styled.h2`
  width: fit-content;
`;

export const ButtonAdd = styled(Button)`
  &.no-margin {
    margin: 0 !important;
    height: 38px;
    width: 171px;
  }
`;

const MainContent = styled.div`
  .card-content {
    box-shadow: 0px 6px 20px var(--vo-cloud);
    border-radius: 8px;
    background-color: var(--vo-white);
    display: flex;
    flex-direction: column;
    padding: 24px;
    width: 100%;
    margin: 32px auto 0;
  }
`;

export const Main = ({ children, title, breadcrumb, showButtonAdd, linkPage, actionButton }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <MainWrapper>
      {title && (
        <div className="headerMenu container">
          <div>
            <Row>
              <Column>
                <h1 className="clickable title" data-tour="page-title" onClick={() => navigate(linkPage)}>
                  {title}
                </h1>
              </Column>
            </Row>
            <Row alignItems="center">
              <Column xs={6}>{breadcrumb && <Subtitle className="subtitle">{breadcrumb}</Subtitle>}</Column>
              <Column xs={6} justifyContent="end" className="d-flex">
                {showButtonAdd && (
                  <ButtonAdd data-tour="add-button" className="no-margin" onClick={() => navigate('add')}>
                    {t('buttons.addNew')}
                  </ButtonAdd>
                )}
                {actionButton}
              </Column>
            </Row>
          </div>
        </div>
      )}
      <MainContent>{children}</MainContent>
      <ToastContainer />
    </MainWrapper>
  );
};
